<div class="loading-container">
  @if (isLoading$ | async) {
    <p-progressBar mode="indeterminate" [style]="{ height: '6px' }"/>
  }
</div>